<template>
  <svg class="radar-chart" viewBox="0 0 320 290" role="img" aria-label="6개 메타인지 수학 역량 레이더 그래프">
    <g transform="translate(160 137)">
      <polygon
        v-for="level in [1, 2, 3, 4, 5]"
        :key="level"
        :points="gridPoints(level)"
        class="radar-chart__grid"
      />
      <line
        v-for="index in 6"
        :key="`axis-${index}`"
        x1="0"
        y1="0"
        :x2="axisPoint(index - 1, 5).x"
        :y2="axisPoint(index - 1, 5).y"
        class="radar-chart__axis"
      />
      <polygon :points="dataPoints" class="radar-chart__data" />
      <circle
        v-for="(point, index) in scorePoints"
        :key="`score-${index}`"
        :cx="point.x"
        :cy="point.y"
        r="3.5"
        class="radar-chart__dot"
      />
    </g>
    <text
      v-for="(label, index) in labels"
      :key="label"
      :x="labelPoint(index).x"
      :y="labelPoint(index).y"
      :text-anchor="labelPoint(index).anchor"
      class="radar-chart__label"
    >{{ shortLabel(label) }}</text>
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  labels: string[]
  scores: number[]
}>()

const radius = 92
const centerX = 160
const centerY = 137

function axisPoint(index: number, level: number): { x: number; y: number } {
  const angle = -Math.PI / 2 + index * (Math.PI / 3)
  const r = radius * (level / 5)
  return { x: Math.cos(angle) * r, y: Math.sin(angle) * r }
}

function gridPoints(level: number): string {
  return Array.from({ length: 6 }, (_, index) => {
    const point = axisPoint(index, level)
    return `${point.x},${point.y}`
  }).join(' ')
}

const scorePoints = computed(() => props.scores.map((score, index) => axisPoint(index, score)))
const dataPoints = computed(() => scorePoints.value.map((point) => `${point.x},${point.y}`).join(' '))

function labelPoint(index: number): { x: number; y: number; anchor: 'start' | 'middle' | 'end' } {
  const angle = -Math.PI / 2 + index * (Math.PI / 3)
  const r = 126
  const x = centerX + Math.cos(angle) * r
  const y = centerY + Math.sin(angle) * r + 4
  const cosine = Math.cos(angle)
  const anchor = Math.abs(cosine) < 0.2 ? 'middle' : cosine > 0 ? 'start' : 'end'
  return { x, y, anchor }
}

function shortLabel(label: string): string {
  return label.replace('·오류 인식', '').replace('·대수 조작', '').replace('·레퍼토리', '')
}
</script>
